{
  "EMOJI": {
    "PLACEHOLDER": "Пошук смайлів",
    "NOT_FOUND": "Немає смайликів, які відповідають вашому запиту",
    "REMOVE": "Видалити"
  }
}
